import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useProjects } from '../hooks/useProjects'
import { useSyncProject } from '../hooks/useProjectMutations'

/** Project object page: structure + a manifest-sync panel. */
export function ProjectDetailPage() {
  const { t } = useTranslation()
  const { id = '' } = useParams()
  const { data: projects } = useProjects()
  const project = (projects ?? []).find((p) => p.id === id)
  const sync = useSyncProject(id)
  const [manifest, setManifest] = useState('')

  if (!project) {
    return (
      <section>
        <Link to="/" className="text-sm text-blue-600">{t('detail.back')}</Link>
        <p className="mt-6 text-neutral-400">{t('detail.notFound')}</p>
      </section>
    )
  }

  return (
    <section className="max-w-2xl">
      <Link to="/" className="text-sm text-blue-600">{t('detail.back')}</Link>
      <h2 className="mt-2 text-xl font-semibold">{project.name}</h2>
      <dl className="mt-4 grid grid-cols-[8rem_1fr] gap-y-2 text-sm">
        <dt className="text-neutral-500">{t('detail.repo')}</dt><dd>{project.repoUrl}</dd>
        <dt className="text-neutral-500">{t('detail.source')}</dt><dd>{project.ingestionSource}</dd>
        <dt className="text-neutral-500">{t('detail.status')}</dt><dd>{project.status}</dd>
        <dt className="text-neutral-500">{t('detail.lastSync')}</dt>
        <dd>{project.lastSyncedAt ?? t('detail.never')}</dd>
      </dl>

      <div className="mt-8">
        <h3 className="font-medium">{t('detail.syncTitle')}</h3>
        <textarea
          value={manifest}
          onChange={(e) => setManifest(e.target.value)}
          placeholder={t('detail.syncPlaceholder')}
          className="mt-2 h-40 w-full rounded border border-neutral-300 p-2 font-mono text-xs dark:bg-neutral-800"
        />
        <button
          type="button"
          disabled={manifest.trim() === '' || sync.isPending}
          onClick={() => sync.mutate({ content: manifest })}
          className="mt-2 rounded bg-neutral-900 px-3 py-2 text-sm text-white disabled:opacity-40 dark:bg-neutral-100 dark:text-neutral-900"
        >
          {t('detail.sync')}
        </button>
        {sync.isSuccess && (
          <p className="mt-2 text-sm text-green-600">
            {t('detail.syncOk', { added: sync.data.added, conflicts: sync.data.conflicts.length })}
          </p>
        )}
        {sync.isError && <p className="mt-2 text-sm text-red-600">{t('detail.syncError')}</p>}
      </div>
    </section>
  )
}
